<script setup>
import "@/assets/new-style/all.css";
import "@/assets/new-style/uikit.css";
import { EVENTS } from "@/lib/events";
import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/vue';


import { defineEmits } from "vue";
// import {useStore} from "vuex";
import { v4 } from "uuid";
import { useRouter } from "vue-router";

// const store = useStore();
const router = useRouter();

const emit = defineEmits(['createLobby']);
const slides = [
  {
    id: EVENTS.VDNH,
    photo: require("@/assets/vdnh.png"),
    link: 'http//sharelink',
    title: 'Прогулка в МетаВДНХ',
    description: ' Сегодня главную выставку страны можно увидеть не выходя из дома! Отправьтесь на виртуальную прогулку по ВДНХ в ее детально воссозданном цифровом двойнике. '
  },
  {
    id: EVENTS.AVELEKS,
    photo: require("@/assets/vanya.png"),
    link: 'http//sharelink',
    title: 'Виртуальная экскурсия с Ваней Дмитриенко',
    description: 'Отправьтесь в интерактивное путешествие во времени, чтобы узнать историю мирного атома, космоса и кино в виртуальной экскурсии по ВДНХ!'
  },
  {
    id: EVENTS.CHRONICLES,
    photo: require("@/assets/chronicles-bg.png"),
    link: 'http//sharelink',
    title: 'Хроники Победы',
    description: 'К 80-летию Великой Победы: архивные кадры и уникальный опыт виртуального погружения в историю. Благодаря проекту каждый гость МетаВДНХ может узнать больше о событиях Великой Отечественной войны и почтить память героев. В цифровой копии «Зеленого театра» можно посмотреть исторические кадры и архивные съемки, послушать и спеть песни той эпохи, узнать больше о подвиге народа, важности 80-летия Великой Победы для потомков.'
  },
  {
    id: EVENTS.RUSSIA,
    photo: require("@/assets/russia.png"),
    link: 'http//sharelink',
    title: 'Международная выставка-форум «Россия»',
    description: 'Посетите уникальные экспозиции международной выставки-форума «России» в метавселенной. Выбирайте удобное время и отправляйтесь на прогулку!'
  },
  {
    id: EVENTS.ATOM,
    photo: require("@/assets/atom-bg.png"),
    link: 'http//sharelink',
    title: 'Музей АТОМ',
    description: 'Добро пожаловать в музей “АТОМ” — здесь начинается ваше увлекательное путешествие. В «Атомариуме» вы найдете ответы на вопросы о законах природы и физики, а экспозиция «Современная атомная промышленность» расскажет о применении атомных технологий. Готовы к погружению?'
  },
]


function createSoloLobby(id) {
  sessionStorage.setItem("lobby-type", id);
  sessionStorage.setItem('eventId', v4());
  sessionStorage.setItem('eventId', v4());
  sessionStorage.setItem('internalId', v4());
  sessionStorage.setItem('eventType', 'dedicatedTour');
  sessionStorage.setItem('soloLobby', 'true');
  // store.commit('changeUserRole', 'guide');
  router.push({name: 'gamePage'});

}
</script>

<template>
  <section class="section friends  purple-bg">
    <div class="friends-content container">
      <div class="friends-filling ">
        <div class="friends-info">
          <p class="friends-info__title">Играйте с друзьями без предварительной записи!</p>
          <p class="friends-info__text">Вы можете посетить все мероприятия МетаВДНХ без предварительной записи, но для
            этого необходим компьютер со следующими техническими характеристиками.</p>
        </div>
        <swiper :space-between="16" :grab-cursor="true" :slides-per-view="1.5" class="swiper">
          <swiper-slide v-for="item in slides" :key="item.id" class="slide">
            <div class="slide-photo">
              <!-- <div class="slide-copy">
                <p class="slide-copy__text line-limit-1">{{ item.link }}</p>
                <button class="slide-copy__btn"></button>
              </div> -->
              <img :src="item.photo" alt="" class="slide-photo__img">
            </div>
            <div class="slide-content">
              <p class="slide__title line-limit-3">{{ item.title }}</p>
              <p class="slide__text line-limit-4">{{ item.description }}</p>
              <div class="slide-footer">
                <button class="link link--small link--white" @click="createSoloLobby(item.id)">
                  Играть одному
                </button>
                <button @click="emit('createLobby', item.id)" class="link link--small">
                  Играть с друзьями
                </button>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.friends {
  padding: 3.75rem 0;

  &-filling {
    display: flex;
    align-items: flex-start;
    border-radius: 2rem;
    background: #fff;
    padding: 6rem 0 6rem 4.5rem;
    gap: 3.875rem;
    overflow: hidden;
  }

  &-info {
    max-width: 100%;
    width: 100%;
    position: relative;
    z-index: 2;

    &__title {
      font-weight: 500;
      font-size: 3.12rem;
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #05141f;
    }

    &__text {
      margin-top: 1.875rem;
      font-size: 0.94rem;
      line-height: 167%;
      color: #05141f;
    }
  }

  .swiper {
    max-width: 43.3rem;
    width: 100%;
    display: grid;
    flex-shrink: 0;
  }

  .slide {
    max-width: 27.5rem;
    width: 100%;
    background: #00288C;
    padding: 1.25rem;
    border-radius: 2.12rem;
    height: 100%;
    display: flex;
    flex-direction: column;


    &-photo {
      padding: 1rem;
      position: relative;
      padding-bottom: 56.25%;
      display: flex;
      justify-content: flex-end;


      &__img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        border-radius: 1.25rem;
      }
    }

    &-copy {
      position: absolute;
      z-index: 1;
      padding: 0.25rem 0.25rem 0.25rem 1.25rem;
      backdrop-filter: blur(120px);
      background: rgba(255, 255, 255, 0.4);
      display: flex;
      max-width: 100%;
      align-items: center;
      border-radius: 62.5rem;
      gap: 1.25rem;

      &__text {
        font-weight: 500;
        font-size: 1rem;
        line-height: 75%;
        color: #fff;
      }

      &__btn {
        display: flex;
        flex-shrink: 0;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 100%;
        background-color: #fff;
        background-image: url("@/assets/new-icons/copy.svg");
        background-size: 1.25rem;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
      }
    }

    &-content {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    &__title {
      margin-top: 1.375rem;
      font-weight: 500;
      font-size: 2rem;
      line-height: 100%;
      letter-spacing: 0.01em;
      color: #fff;
    }

    &__text {
      margin-top: 1rem;
      font-weight: 500;
      font-size: 1.12rem;
      line-height: 133%;
      letter-spacing: 0.01em;
      color: rgba(255, 255, 255, 0.8);
    }

    &-footer {
      padding-top: 1rem;
      margin-top: auto;
      display: flex;
      gap: 0.5rem;
    }

    .link {
      &--white {
        background: #fff;
        color: #000;
      }
    }
  }

  .slide:nth-child(2n) {
    background: #A5C3F0;
  }
}
</style>